module.exports = __webpack_public_path__ + "img/Talk Graphic 4.94446c12.png";